import { ISamsungSSPTier } from '~/src/dash/api/demand-settings/samsungssp/samsungssp-tiers_models';
import { createUrl, restGet, restPatch } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';

export async function getSamsungSSPTiersForPublisher(
  publisherID: string,
): Promise<ISamsungSSPTier[] | undefined> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/samsungssp-tiers', publisherID);

  try {
    return (await restGet<ISamsungSSPTier[]>(reqUrl)).parsedBody as ISamsungSSPTier[];
  } catch (e) {
    throw e;
  }
}

export async function updateSamsungSSPTiersForPublisher(
  publisherID: string,
  tiers: ISamsungSSPTier[],
): Promise<ISamsungSSPTier[] | undefined> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/samsungssp-tiers', publisherID);

  try {
    return (await restPatch<ISamsungSSPTier[]>(reqUrl, tiers)).parsedBody as ISamsungSSPTier[];
  } catch (e) {
    throw e;
  }
}

// is enabled?
export async function getSamsungSSPTiersEnabledForPublisher(
  publisherID: string,
): Promise<EBool | undefined> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/samsungssp-tiers-enabled', publisherID);

  try {
    return (await restGet<EBool>(reqUrl)).parsedBody as EBool;
  } catch (e) {
    throw e;
  }
}

export async function updateSamsungSSPTiersEnabledForPublisher(
  publisherID: string,
  isEnabled: EBool,
): Promise<EBool | undefined> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/samsungssp-tiers-enabled', publisherID);

  try {
    return (await restPatch<EBool>(reqUrl, isEnabled)).parsedBody as EBool;
  } catch (e) {
    throw e;
  }
}
